import { VIEW_WIDGETS } from "../../../../../../../../../../gis/components/odnr-map/models/widgets.model";

export interface WidgetConfig {
    type: VIEW_WIDGETS;
    position: 'bottom-leading' | 'bottom-left' | 'bottom-right' | 'bottom-trailing' | 'top-leading' | 'top-left' | 'top-right' | 'top-trailing' | 'manual';
}

export enum WidgetPosition {
    topLeft = 'top-left',
    topRight = 'top-right',
    top = 'top-leading',
    bottomLeft = 'bottom-left',
    bottom = 'bottom-leading',
    bottomRight = 'bottom-right'
}